var path = '/templates/projects.iw/iw_navigation.html';
var html = "<ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=\"admin.projects.iw.report({projectId: $ctrl.project.id})\"><i class=\"fa fa-bar-chart\"></i> {{ 'projectsIw.navigation.deliveryReport' | translate }}</a></li><li ui-sref-active=active><a ui-sref=\"admin.projects.iw.items({projectId: $ctrl.project.id})\"><i class=\"fa fa-barcode\"></i> {{ 'projectsIw.navigation.itemReport' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.iw/iw_navigation.html
// module id = 1421
// module chunks = 0